export const industryArray = [
  {
    src: "/construction.png",
    text: "Construction",
  },
  {
    src: "/car.png",
    text: "Automotive",
  },
  {
    src: "/home.png",
    text: "Retail and Wholesale",
  },
  {
    src: "/solar.png",
    text: "Utilities",
  },
  {
    src: "/tech.png",
    text: "Aviation & Aerospace",
  },
  {
    src: "/bank.png",
    text: "Sports & Recreation",
  },
];

export const industrySearch = [
  "Construction",
  "Energy",
  "Healthcare",
  "Manufacturing",
  "Real Estate",
  "Transportation",
  "Automotive",
  "Aviation & Aerospace",
  "Financial Institutions",
  "Hospitality",
  "Life Sciences",
  "Marine",
  "Non-profit Practice",
  "Oil and Gas",
  "Professional Services",
  "Retail and Wholesale",
  "School Districts & Higher Education",
  "Agriculture & Agribusiness",
  "Architecture & Design",
  "Biotechnology",
  "Chemicals & Materials",
  "Consumer Goods",
  "Cybersecurity",
  "Defense & Military",
  "E-commerce",
  "Education (K-12)",
  "Entertainment & Media",
  "Environmental Services",
  "Food & Beverage",
  "Government & Public Sector",
  "Information Technology (IT)",
  "Insurance",
  "Legal Services",
  "Logistics & Supply Chain",
  "Marketing & Advertising",
  "Pharmaceuticals",
  "Private Equity & Venture Capital",
  "Renewable Energy",
  "SaaS / Software",
  "Sports & Recreation",
  "Telecommunications",
  "Utilities",
  "Veterinary & Animal Care",
  "Warehousing & Distribution",
  "Wellness & Fitness",
];

export const sellingArray = [
  {
    src: "/construction.png",
    text: "Condo Insurance",
  },
  {
    src: "/car.png",
    text: "CRM software",
  },
  {
    src: "/home.png",
    text: "Real Estate",
  },
  {
    src: "/solar.png",
    text: "Solar",
  },
  {
    src: "/tech.png",
    text: "Technology",
  },
  {
    src: "/bank.png",
    text: "Financial Institutions",
  },
];

export const sellingSearch = [
  "CRM Software",
  "Condo Insurance",
  "Marketing Services",
  "IT Services",
  "Cybersecurity Solutions",
  "Payroll & HR Services",
  "SaaS Product",
  "Construction Services",
  "Legal Services",
  "Commercial Cleaning",
  "Business Consulting",
  "Financial Services",
  "Commercial Real Estate",
  "Office Supplies / Equipment",
  "Telecom / Internet Services",
  "Employee Benefits",
  "Manufacturing Equipment",
  "Logistics / Freight Services",
  "Training & Development",
  "Healthcare Solutions",
  "Recruiting / Staffing Services",
  "Energy / Utility Services",
  "Security Systems / Access Control",
  "Medical Devices",
];

export const sellingToArray = [
  {
    src: "/construction.png",
    text: "Chief Executive Officer (CEO)",
  },
  {
    src: "/car.png",
    text: "Condo Board",
  },
  {
    src: "/home.png",
    text: "Human Resources Director",
  },
  {
    src: "/solar.png",
    text: "Business Owner",
  },
  {
    src: "/tech.png",
    text: "Startup",
  },
  {
    src: "/bank.png",
    text: "Government Administrator",
  },
];

export const sellingToSearch = [
  "CEO / President",
  "Business Owner",
  "Founder / Co-Founder",
  "Condo / HOA Board Member",
  "Property Manager",
  "Human Resources Director",
  "Director of Operations",
  "Facilities Manager",
  "CFO / Finance Director",
  "IT Director / CIO",
  "Marketing Director",
  "Sales Leader / VP of Sales",
  "School Principal",
  "Superintendent",
  "Procurement Manager",
  "Legal Counsel / Compliance Officer",
  "Office Manager",
  "Practice Manager (Healthcare)",
  "Non-Profit Executive Director",
  "General Manager",
  "Government Administrator",
];

export const customerIndustryArray = [
  {
    src: "/construction.png",
    text: "Construction",
  },
  {
    src: "/car.png",
    text: "Energy",
  },
  {
    src: "/home.png",
    text: "Healthcare",
  },
  {
    src: "/solar.png",
    text: "Manufacturing",
  },
  {
    src: "/tech.png",
    text: "Real Estate",
  },
  {
    src: "/bank.png",
    text: "Transportation",
  },
];

export const difficultyArray = [
  {
    src: "/easy.png",
    text: "Easy",
  },
  {
    src: "/medium.png",
    text: "Medium",
  },
  {
    src: "/hard.png",
    text: "Hard",
  },
];

export const businessModalArray = [
  {
    src: "/b2b.png",
    text: "Business to Consumer",
    val: "b2c",
    subText: "(I’m Talking to an Individual)",
  },
  {
    src: "/b2c.png",
    text: "Business to Business",
    val: "b2b",
    subText: "(I’m Talking to a Company)",
  },
];

export const stepsArray = [
  {
    step: "Step 01",
    text: "Define your Role",
  },
  {
    step: "Step 02",
    text: "Define the prospect",
  },
  {
    step: "Step 03",
    text: "Select Difficulty",
  },
];

export const sidebarLinks = [
  {
    imgURL: "/icons/home.svg",
    route: "/",
    label: "Home",
  },
  {
    imgURL: "/icons/users.svg",
    route: "/community",
    label: "Community",
  },
  {
    imgURL: "/icons/star.svg",
    route: "/collection",
    label: "Collections",
  },
  {
    imgURL: "/icons/suitcase.svg",
    route: "/jobs",
    label: "Find Jobs",
  },
  {
    imgURL: "/icons/tag.svg",
    route: "/tags",
    label: "Tags",
  },
  {
    imgURL: "/icons/user.svg",
    route: "/profile",
    label: "Profile",
  },
  {
    imgURL: "/icons/question.svg",
    route: "/ask-question",
    label: "Ask a question",
  },
];

export const b2cIdealCustomerArray = [
  {
    src: "/construction.png",
    text: "First-Time Buyers",
  },
  {
    src: "/car.png",
    text: "Budget-Conscious Shoppers",
  },
  {
    src: "/home.png",
    text: "Trendsetters/Early Adopters",
  },
  {
    src: "/solar.png",
    text: "Family-Oriented Consumers",
  },
  {
    src: "/tech.png",
    text: "Young Professionals",
  },
  {
    src: "/bank.png",
    text: "Fitness Enthusiasts",
  },
];

export const idealCustomerSearch = [
  "Young Professionals",
  "Parents with Young Children",
  "College Students",
  "Retirees / Seniors",
  "Remote Workers / Digital Nomads",
  "High-Income Individuals",
  "Small Business Owners (B2C-focused)",
  "Busy Professionals",
  "Pet Owners",
  "Eco-Conscious Consumers",
  "Outdoor Enthusiasts",
  "Beauty & Wellness Seekers",
  "Car Enthusiasts",
  "Health-Conscious Shoppers",
  "Gamers & Tech Fans",
  "Luxury Lifestyle Seekers",
  "Homeowners",
  "Renters / Apartment Dwellers",
  "Expecting Parents / New Parents",
  "DIYers / Hobbyists",
  "Travelers / Frequent Flyers",
  "Newlyweds",
  "First-time Home Buyers",
  "Fitness Enthusiasts",
];

export const b2cAgeArray = [
  {
    text: "18 - 25 years",
    src: "/tech.png",
  },
  {
    text: "26 - 40 years",
    src: "/tech.png",
  },
  {
    text: "41 - 45 years",
    src: "/tech.png",
  },
  {
    text: "46 - 55 years",
    src: "/tech.png",
  },
  {
    text: "56 - 65 years",
    src: "/tech.png",
  },
  {
    text: "66+ years",
    src: "/tech.png",
  },
];

export const b2cGenderArray = [
  {
    text: "Male",
    src: "/tech.png",
  },
  {
    text: "Female",
    src: "/tech.png",
  },
  {
    text: "Other",
    src: "/tech.png",
  },
];

export const b2cIncomeArray = [
  {
    text: "low Income Group",
    src: "/tech.png",
  },
  {
    text: "Middle Income Group",
    src: "/tech.png",
  },
  {
    text: "High Income Group",
    src: "/tech.png",
  },
];

export const b2cMotivateArray = [
  {
    text: "Not Sure",
    src: "/tech.png",
  },
  {
    text: "Quality & Durability",
    src: "/tech.png",
  },
  {
    text: "Ease of Accessibility",
    src: "/tech.png",
  },
  {
    text: "Innovation",
    src: "/tech.png",
  },
  {
    text: "Educational Value",
    src: "/tech.png",
  },
  {
    text: "Safety and Security",
    src: "/tech.png",
  },
];

export const motivatesSearch = [
  "Ease & Accessibility",
  "Innovation",
  "Educational Value",
  "Safety & Security",
  "Status / Prestige",
  "Simplicity / Convenience",
  "Customer Support / Service",
  "Personalization",
  "Speed / Time Savings",
  "Reliability",
  "Compliance / Risk Reduction",
  "ROI / Profitability",
  "Sustainability / Eco-Consciousness",
  "Community Impact / Social Good",
  "Trust in Brand / Reputation",
  "Scalability",
  "Data / Performance Insights",
  "Exclusivity / Limited Access",
  "Comfort / Usability",
  "Avoiding Pain / Problems",
  "Integration with Existing Systems",
  "Value for Money",
  "Quality & Durability",
];

export const rolesArray = [
  {
    image: "/salesman.png",
    heading: "Aspiring Salesperson",
    subHeading: "I’m new to presenting and want to improve my confidence",
    role: "user",
  },
  {
    image: "/professional.png",
    heading: "Professional",
    subHeading: "I’m looking to refine my pitches for business success.",
    role: "professional",
  },
  {
    image: "/teamLeader.png",
    heading: "Team Leader",
    subHeading: "I want to inspire my team and collaboration",
    role: "teamLeader",
  },
];

type Feature = Record<string, string>;

export type PlanDetails = {
  price: string;
  detail: string;
  id: string;
  features: Feature[];
};

type PlanData = {
  [duration: string]: {
    [planName: string]: PlanDetails;
  }[];
};

export const plans: PlanData[] = [
  {
    Monthly: [
      {
        "Basic Single-User Package": {
          price: "9.99",
          detail: "One free feedback",
          id: "c7a1f7f2-8b4e-4d3e-ae67-2d14fa57b1d1",
          features: [
            {
              "Limited Pitches": "Practice for up to 5 pitches a month",
            },
            {
              "Objection-handling practice":
                "Prepare for real-world sales challenges",
            },
            {
              "Improve at your own pace": "No pressure, just results",
            },
            {
              "Create your Perfect Prospect":
                "Tailor each pitch to your target customer - from industry to personality",
            },
          ],
        },
      },

      {
        "Single-User Package": {
          price: "19.99",
          detail: "",
          id: "f59d7e2c-3c12-4ae4-b7f2-935681a1d49b",

          features: [
            {
              "Unlimited  Pitches": "Practice as much as you want",
            },
            {
              "Graded written feedback":
                "Get AI-powered analysis to improve your pitch",
            },
            {
              "Objection-handling practice":
                "Prepare for real-world sales challenges",
            },
            {
              "Improve at your own pace": "No pressure, just results",
            },
            {
              "Create your Perfect Prospect":
                "Tailor each pitch to your target customer - from industry to personality",
            },
          ],
        },
      },
      {
        "Team Package": {
          price: "15.99",
          detail: "*Requires a minimum of 5 members",
          id: "4b2c1a8f-9f1e-4113-88e4-6bd1f472a25e",

          features: [
            {
              "Manage your team seamlessly":
                "Add & remove unlimited team members",
            },
            {
              "Graded written feedback":
                "Get AI-powered personalized insights for each salesperson",
            },
            {
              "Sales dashboard":
                "Track team output, progress, and improvement areas",
            },
            {
              "Discounted per-user pricing": "Save more as your team grows!",
            },
          ],
        },
      },
    ],
  },
  {
    Annual: [
      {
        "Basic Single-User Package": {
          price: "99.99",
          detail: "One free feedback",
          id: "a2d567bf-e931-4c14-b8a3-4a9711a68ef1",

          features: [
            {
              "Limited Pitches": "Practice for up to 10 pitches a month",
            },
            {
              "Objection-handling practice":
                "Prepare for real-world sales challenges",
            },
            {
              "Improve at your own pace": "No pressure, just results",
            },
            {
              "Create your Perfect Prospect":
                "Tailor each pitch to your target customer - from industry to personality",
            },
          ],
        },
      },

      {
        "Single-User Package": {
          price: "199.99",
          detail: "",
          id: "d4c6f11e-038b-44f1-a8c9-c439c5d13df7",

          features: [
            {
              "Unlimited  Pitches": "Practice as much as you want",
            },
            {
              "Graded written feedback":
                "Get AI-powered analysis to improve your pitch",
            },
            {
              "Objection-handling practice":
                "Prepare for real-world sales challenges",
            },
            {
              "Improve at your own pace": "No pressure, just results",
            },
            {
              "Create your Perfect Prospect":
                "Tailor each pitch to your target customer - from industry to personality",
            },
          ],
        },
      },
      {
        "Team Package": {
          price: "599.99",
          detail: "*Requires a minimum of 5 members",
          id: "1e5f7bc9-6e2f-4f32-8e91-2a81a07a3c84",

          features: [
            {
              "Manage your team seamlessly":
                "Add & remove unlimited team members",
            },
            {
              "Graded written feedback":
                "Get AI-powered personalized insights for each salesperson",
            },
            {
              "Sales dashboard":
                "Track team output, progress, and improvement areas",
            },
            {
              "Discounted per-user pricing": "Save more as your team grows!",
            },
          ],
        },
      },
    ],
  },
];
